export default __webpack_public_path__ + "static/media/season_spring.6b4978cd.avif";